module.exports = __webpack_public_path__ + "img/Pharmaceutical Compounding.a89d913a.jpg";